import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faHouseMedical } from '@fortawesome/pro-regular-svg-icons/faHouseMedical'
import 'maplibre-gl/dist/maplibre-gl.css'
import dynamic from 'next/dynamic'

const DynamicMarker = dynamic(
  () => import('react-map-gl/dist/es5/components/marker'),
  { loading: () => <div>...</div>, ssr: false },
)

export const LocationPin = ({
  location,
  onClick,
  selected,
}: {
  location: {
    facility: string | null
    lat: string | null
    lng: string | null
  }
  onClick: () => void
  selected: boolean
}) => {
  const lat = parseFloat(location.lat ?? '')
  const lng = parseFloat(location.lng ?? '')

  return (
    <DynamicMarker
      latitude={lat}
      longitude={lng}
      onClick={onClick}
      style={{ zIndex: selected ? '1' : 'unset' }}
    >
      <div className={classMerge('text-center', selected && 'mt-4')}>
        <div className='relative'>
          <Icon
            className={classMerge(
              'cursor-pointer rounded-lg p-2',
              selected
                ? 'bg-primary500 text-white'
                : 'bg-white text-primary500',
            )}
            icon={faHouseMedical}
          />
        </div>
        {selected && (
          <Text
            className='rounded-full bg-primary500 px-4 py-2 text-white'
            styleName='p-xxtiny'
            value={location.facility}
          />
        )}
      </div>
    </DynamicMarker>
  )
}
